/* @ngInject */

export default () => {
  return {
    restrict: 'A',
    scope: {
      stInputDefaultValue: '@'
    },
    link: function (scope, element, attrs) {
      var defaultValue = attrs.stInputDefaultValue.toString();
      element
        .bind('focus', function () {
          if (element.val().toString() === defaultValue) {
            element.val('');
          }
        })
        .bind('blur', function () {
          if (element.val().toString() === '' || element.val().toString() === defaultValue) {
            element.val(defaultValue);
            var $e = angular.element(element);
            $e.triggerHandler('input');
          }
        });
    }
  };
};
